import { Route, Routes } from "react-router-dom";

import FreeAuthRoute from "src/routes/FreeAuthRoute";
import ProtectedRoute from "src/routes/ProtectedRoute";

import Dashboard from "src/pages/Dashboard";
import ErrorPage from "src/pages/auth/404";
import Login from "src/pages/auth/Login";
import Logout from "src/pages/auth/Logout";
import PermissionDenied from "src/pages/auth/PermissionDenied";
import SSOLogin from "src/pages/auth/SSOLogin";
import ForgotPassword from "src/pages/forgot-password/ForgotPassword";
import ResetPassword from "src/pages/forgot-password/ResetPassword";
import Dashboard2 from "src/pages/Dashboard2";

const AppRoutes = () => {
  return (
    <Routes>
      {/* NOT PROTECTED routes */}
      <Route
        path="/"
        element={<FreeAuthRoute />}>
        <Route
          index
          element={<Login />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/sso-login"
          element={<SSOLogin />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/forgot-password/reset-password/:token"
          element={<ResetPassword type="forgot-password" />}
        />

        <Route
          path="/token/:token"
          element={<ResetPassword type="welcome-mail" />}
        />
      </Route>

      {/* PROTECTED routes */}
      <Route
        exact
        path="/"
        element={<ProtectedRoute />}>
        <Route
          exact
          path="/permission-denied"
          element={<PermissionDenied />}
        />
        <Route
          exact
          path="/workspace/:workspace_id/permission-denied"
          element={<PermissionDenied />}
        />
        {/* <Route
          path="/workspace/:workspace_id"
          element={<Dashboard2 />}
        /> */}
        <Route
          path="/workspace/:workspace_id/page/:page_id"
          element={<Dashboard key="linkPage" />}
        />
        <Route
          path="/workspace/:workspace_id/group/:group_id/page/:page_id"
          element={<Dashboard key="groupPage" />}
        />
        <Route
          path="/workspace/:workspace_id/embed"
          element={<Dashboard key="embedPage" />}
        />
        <Route
          path="/embed/items/:workspace_id/:page_id"
          element={
            <Dashboard
              nested
              key="nestedPage"
            />
          }
        />
      </Route>
      <Route
        path="/logout"
        element={<Logout />}
      />
      <Route
        path="*"
        element={<ErrorPage />}
      />
    </Routes>
  );
};

export default AppRoutes;
